import { useTheme } from './ThemeProvider';

/**
 * Aviso informativo al abrir Visita concertada tras un retroceso desde Para Revisar.
 * Solo se muestra una vez por usuario y entrada de historial (ver retrocesoVisitaVisto.js).
 */
export default function ModalAvisoRetrocesoVisita({
  isOpen,
  actorNombre,
  motivo,
  onClose,
}) {
  const { theme } = useTheme();
  const c = theme.colors;
  const isDark = theme.name === 'dark';

  if (!isOpen) return null;

  const quien = String(actorNombre || '').trim() || 'Un revisor';
  const textoMotivo = String(motivo || 'Sin detalle').trim() || 'Sin detalle';

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1250,
        background: 'rgba(0,0,0,0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: c.bgPanel,
          borderRadius: 14,
          padding: 22,
          width: '100%',
          maxWidth: 480,
          border: `1px solid ${c.border}`,
          boxShadow: isDark ? '0 16px 48px rgba(0,0,0,0.5)' : '0 16px 48px rgba(0,0,0,0.12)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ fontSize: 16, fontWeight: 700, color: c.textPrimary, marginBottom: 10 }}>
          Captación devuelta a Visita concertada
        </div>
        <p style={{ fontSize: 13, color: c.textSecondary, margin: '0 0 14px', lineHeight: 1.55 }}>
          Esta captación se envió a Visita concertada por{' '}
          <strong style={{ color: c.textPrimary }}>{quien}</strong>
          {' '}con el siguiente motivo:
        </p>
        <div
          style={{
            padding: '12px 14px',
            borderRadius: 10,
            background: isDark ? 'rgba(239,68,68,0.12)' : 'rgba(239,68,68,0.06)',
            border: `1px solid ${isDark ? 'rgba(239,68,68,0.35)' : 'rgba(239,68,68,0.2)'}`,
            fontSize: 13,
            color: c.textPrimary,
            lineHeight: 1.5,
            whiteSpace: 'pre-wrap',
          }}
        >
          {textoMotivo}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 18 }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '9px 18px',
              borderRadius: 8,
              border: 'none',
              background: c.accentBlue || '#2563eb',
              color: '#fff',
              fontSize: 13,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
}
